<template>
    <v-ons-page>
        <ons-toolbar class="main-toolbar">
            <div class="center brand-toobar">
                <img src="/logo_v2.png" class="logo">
            </div>
            <div class="left">
                <a v-on:click="$router.go(-1)">
                    <svg class="icon icon-fit icon-arrow-back" aria-hidden="true"></svg>
                </a>
            </div>
        </ons-toolbar>

        <div class="content">

            <v-ons-progress-bar v-if="show_loading" indeterminate></v-ons-progress-bar>

            <div class="content-inner">
                <p v-show="show_user == false" class="text-centre">Loading user data...</p>
                <v-ons-list v-if="show_user" class="section-h list-no-divider">
                    <v-ons-list-item>
                        <div class="center">
                            Thanks for logging in with &nbsp;
                            <span class="txt-social-google" v-show="user.social_provider == 'google'">
                                <gtc-button v-bind:click="false" icon="icon-google" class="secondary round"/>
                            </span>
                            <span class="txt-social-facebook" v-show="user.social_provider == 'facebook'">
                                <gtc-button v-bind:click="false" icon="icon-facebook" class="secondary round"/>
                            </span>
                        </div>
                    </v-ons-list-item>
                    <div class="sub-header">Your details</div>
                    <v-ons-list-item>
                        <div class="center">Email</div>
                        <div class="right">{{ user.email }}</div>
                    </v-ons-list-item>
                    <v-ons-list-item>
                        <div class="center">
                            <v-ons-input placeholder="Name" float v-model="edit_user.name" type="text">
                            </v-ons-input>
                        </div>
                    </v-ons-list-item>
                    <v-ons-list-item>
                        <div class="center">
                            <v-ons-input placeholder="Phone" float v-model="edit_user.phone" type="tel">
                            </v-ons-input>
                        </div>
                    </v-ons-list-item>
                    <section class="section-vh">
                        <gtc-button v-on:click="submit" modifier="large" class="btn-action">
                            Complete signup
                        </gtc-button>
                    </section>
                </v-ons-list>
            </div>
        </div>

        <validation v-bind:show="validation.show"
                    v-bind:errors="validation.errors"
                    v-on:show="(show) => validation.show = show"></validation>
    </v-ons-page>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    import { default as ValidationComponent } from '../fragments/validation'

    export default {

        mounted(){

            const params = {}
            params.provider = this.$route.params.provider
            params.token = this.$route.params.token

            // No parameters - this would be caused by the user refreshing this page which should only be redirected to
            // internally
            if (params.provider == null || params.token == null) {
                this.$router.replace({ name: 'Login' })
                return
            }

            this.loading = true

            this.app.http.get('auth/social/login', params)
                .then(response => {

                    this.app.analytics.track('socialLogin')

                    // If we're logging in an existing social user
                    if (response.data.user_complete){
                        this.$store.commit('login', response.data)
                        this.redirect()
                        this.$ons.notification.toast('Welcome, ' + response.data.user.name, { timeout: 2000 })
                    }
                    // Completing setup for a new user
                    else {
                        this.loading = false
                        this.user_token = response.data.token

                        const user = response.data.user
                        this.user = user
                        this.edit_user = {
                            name: user.name,
                            phone: user.phone,
                        }
                        this.show_user = true
                    }
                })
                .catch(error => {
                    this.loading = false
                    this.$ons.notification.alert(
                            this.app.getResponseErrorMessage(error),
                            { title: 'Unable to login' }
                        )
                        .then(() => this.$router.replace({ name: 'Login' }))
                })

        },

        components: {
            'validation': ValidationComponent,
        },

        data () {
            return {
                app: this.$root.$data.app,
                show_user: false,
                user: null,
                edit_user: {
                    name: '',
                    phone: '',
                },
                user_token: null,
                loading: false,
                validation: {
                    show: false,
                    errors: [],
                }
            }
        },

        methods: {

            ...mapMutations([
                'setLoginRedirect',
            ]),

            redirect(){

                let route = this.app.homeRoute()

                // Load saved state
                if (this.loginRedirect && this.loginRedirect.order_outlet){
                    route = { 
                        name: 'CreateOrder', 
                        params: {outlet_slug: this.loginRedirect.order_outlet} 
                    }
                    this.setLoginRedirect(null)
                }

                // Pushing the new route immediately causes an error in some browsers, potentially due to the rapid
                // update of DOM elements. Delaying by a second seems to fix it, the user is shown a loading bar
                // anyway.
                setTimeout(() => {
                    this.$router.push(route)
                }, 1000)
            },

            submit(){

                this.loading = true

                // Complete the signup. We're passing the auth token manually
                // at this point as the user is not currently logged in
                const settings = {
                    headers: {
                        Authorization: 'Bearer ' + this.user_token
                    }
                }
                this.edit_user.phone = this.filters.noSpace(this.edit_user.phone)
                this.app.http.post('auth/social/complete', this.edit_user, settings)
                    .then(response => {
                        this.$store.commit('login', response.data)
                        this.$ons.notification.alert(
                            'Thanks for signing up, your account is now active.',
                            { title: 'You\'re all set' }
                        )
                        this.redirect()
                    })
                    .catch(error => {
                        this.loading = false
                        if (error.response && error.response.data && error.response.data.errors){
                            this.validation.show = true
                            this.validation.errors = error.response.data.errors
                        } else {
                            this.$ons.notification.alert(
                                this.app.getResponseErrorMessage(error),
                                { title: 'Error' }
                            )
                        }
                    })
            }
        },

        computed: {
            ...mapGetters([
                'embed',
                'loginRedirect',
            ]),

            show_loading: function(){
                return this.loading && this.user == null
            },
        },

    }
</script>

<style scoped>
    .txt-social-google {
        color: #d34836;
    }

    .txt-social-facebook {
        color: #3b5998;
    }
</style>


// WEBPACK FOOTER //
// src/js/components/user/login_social.vue